import React, {createContext} from 'react'
import {useSelector} from 'react-redux'
import {Hotel} from '@findhotel/sapi'
import {getIsHotelDetailsOpenOnLanding} from 'modules/search/selectors'

type Props = {
  /* The hotel id */
  hotelId: string | Hotel['objectID']
  /* Whether the hotel is an anchor hotel */
  isAnchor?: boolean
  children: React.ReactNode
}

type InitialValues = {
  hotelId: string
  isAnchor?: boolean
  hotelDetailsIsOpenOnLanding?: boolean
}

const initialValues: InitialValues = {
  hotelId: undefined,
  isAnchor: false,
  hotelDetailsIsOpenOnLanding: false
}

export const HotelCardContext = createContext(initialValues)

/**
 * This context provider should only be used to access pieces of state that are not available directly from the store
 */
export const HotelCardProvider = ({
  children,
  hotelId,
  isAnchor = false
}: Props) => {
  const hotelDetailsIsOpenOnLanding = useSelector(
    getIsHotelDetailsOpenOnLanding
  )

  return (
    <HotelCardContext.Provider
      value={{
        hotelId,
        isAnchor,
        hotelDetailsIsOpenOnLanding
      }}
    >
      {children}
    </HotelCardContext.Provider>
  )
}
